import { render } from "./Forgot.vue?vue&type=template&id=4c6b805a&scoped=true"
import script from "./Forgot.vue?vue&type=script&lang=js"
export * from "./Forgot.vue?vue&type=script&lang=js"

import "./Forgot.vue?vue&type=style&index=0&id=4c6b805a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c6b805a"],['__file',"src/components/Forgot.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c6b805a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c6b805a', __exports__)) {
    api.reload('4c6b805a', __exports__)
  }
  
  module.hot.accept("./Forgot.vue?vue&type=template&id=4c6b805a&scoped=true", () => {
    api.rerender('4c6b805a', render)
  })

}


export default __exports__